import { render, staticRenderFns } from "./DefaultK12MenuLayout.vue?vue&type=template&id=0918d332&scoped=true"
import script from "./DefaultK12MenuLayout.vue?vue&type=script&lang=ts"
export * from "./DefaultK12MenuLayout.vue?vue&type=script&lang=ts"
import style0 from "./DefaultK12MenuLayout.vue?vue&type=style&index=0&id=0918d332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0918d332",
  null
  
)

export default component.exports